import {
  CRUD_CHANGE_LIST_PARAMS,
  CRUD_GET_LIST_SUCCESS,
  CRUD_GET_LIST
} from '../../../actions';

const defaultState = {
  sort: {
    field: 'id',
    order: 'desc'
  },
  filter: {},
  pagination: {
    page: 1,
    perPage: 10
  }
};

const paramsReducer = (previousState = defaultState, action) => {

  switch (action.type) {
    case CRUD_CHANGE_LIST_PARAMS:
    case CRUD_GET_LIST:
      return {
        sort: action.payload.sort || { field: 'id', order: 'desc'},
        filter: action.payload.filter || {},
        pagination: action.payload.pagination || { page: 1, perPage: 10},
      };
    default:
      return previousState;
  }
};

export default paramsReducer;
